export default __webpack_public_path__ + "static/DSC_0173-42e00062430076cfa67c1b645bc2db71.jpg";